export const SESSIONSTATE_CHANGE = 'SESSIONSTATE_CHANGE';
export const SESSIONSTATE_DELETE = 'SESSIONSTATE_DELETE';
